import ExportPlugin from './ExportPlugin';

export default ExportPlugin;
